import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LayoutComponent } from './layout/layout.component';
import { AngularImporterModule } from '../importers/angular-importer.module';
import { PrimeNGImporterModule } from '../importers/prime-ng-importer.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormInvalidMessageComponent } from './form-invalid-message/form-invalid-message.component';
import { LoadingComponent } from './loading/loading.component';
import { TableComponent } from './table/table.component';
import { BooleanIconComponent } from './boolean-icon/boolean-icon.component';
import { SearchResultPanelComponent } from './search-result-panel/search-result-panel.component';
import { SearchCriteriaPanelComponent } from './search-criteria-panel/search-criteria-panel.component';
import { DocumentRequiredTableComponent } from './document-required-table/document-required-table.component';
import { DocumentRequiredTableConfig } from '../configs/document-required-table.config';
import { TextareaComponent } from './textarea/textarea.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    FormInvalidMessageComponent,
    LoadingComponent,
    TableComponent,
    BooleanIconComponent,
    SearchResultPanelComponent,
    SearchCriteriaPanelComponent,
    DocumentRequiredTableComponent,
  ],
  imports: [
    CommonModule,
    AngularImporterModule,
    PrimeNGImporterModule,
    NgxSpinnerModule,
    TextareaComponent,
  ],
  exports: [
    LayoutComponent,
    LoadingComponent,
    FormInvalidMessageComponent,
    TableComponent,
    BooleanIconComponent,
    SearchResultPanelComponent,
    SearchCriteriaPanelComponent,
    DocumentRequiredTableComponent,
    TextareaComponent,
  ],
  providers: [DocumentRequiredTableConfig],
})
export class ComponentsModule {}
